//#region src/webhook_type.ts
var WebhookType = /* @__PURE__ */ function(WebhookType) {
	WebhookType["FirstParty"] = "first-party";
	WebhookType["ThirdParty"] = "third-party";
	return WebhookType;
}(WebhookType || {});
//#endregion
export { WebhookType };

//# sourceMappingURL=webhook_type.js.map